import TheGrid from '@/views/subactivities/grid'
import Edit from '@/views/subactivities/edit'
import TheView from '@/views/subactivities/view'

export default {
  path: '/subactivities',
  redirect: '/subactivities/index',
  name: 'subactivities',
  meta: {
    auth: {
      redirect: {
        name: 'subactivities.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Subactividades'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'subactivities.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'subactivities.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'subactivities.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }, {
    path: 'view/:id',
    name: 'subactivities.view',
    component: TheView,
    meta: {
      auth: true,
      label: 'Ver'
    }
  }]
}
